module.exports = __webpack_public_path__ + "media/images/about-slider-img-08-8d6fb0edf0947f32e32800dd51e62967.png";